// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_COQB6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Wrappers/SearchResultWrapper/SearchResultWrapper.scss
// module id = 889
// module chunks = 0